import { createContext, useContext } from 'react';
import type { User as FirebaseUser } from 'firebase/auth';
import type { User } from '../lib/types';

export interface AuthState {
  /** `emailVerified` is a snapshot from sign-in; it isn't pushed live (D34). */
  user: (Pick<FirebaseUser, 'uid' | 'email'> & { emailVerified?: boolean }) | null;
  profile: User | null;
  /** true until we know both the auth user and (if signed in) the profile */
  loading: boolean;
}

export const AuthContext = createContext<AuthState>({ user: null, profile: null, loading: true });

export function useAuth(): AuthState {
  return useContext(AuthContext);
}

/** Where a signed-in user belongs. */
export function homePath(profile: User | null): string {
  if (!profile) return '/login';
  if (profile.status === 'pending') return '/awaiting-approval';
  if (profile.status === 'deactivated') return '/deactivated';
  return profile.role === 'admin' ? '/admin' : '/app';
}
